import Model from '~/models/Model';

export default class Occupation extends Model {
  resource() {
    return 'v1/occupations';
  }
}
